import { Pipe } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({
    name: 'safeHtml',
    standalone: false
})
export class SafeHtml {
  constructor(private sanitizer:DomSanitizer){}

  transform(html) {
    if (!html) {
      return html
    }
    this.sanitizer.bypassSecurityTrustHtml(html);
    return this.sanitizer.bypassSecurityTrustResourceUrl(html)
  }
}